"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../../../reducers/slices/main");
var add_product_type_1 = __importDefault(require("../../components/product_details/add_product_type"));
function useActionButtons() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var actionButtons = (0, react_1.useMemo)(function () { return [
        {
            iconClassname: "solar:add-circle-bold",
            label: "Add Product Type",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Add Product Type",
                    content: (0, jsx_runtime_1.jsx)(add_product_type_1.default, { productType: null, isEditing: false }),
                }));
            },
        },
    ]; }, []);
    return (0, react_1.useMemo)(function () { return ({
        actionButtons: actionButtons,
    }); }, [actionButtons]);
}
exports.useActionButtons = useActionButtons;
